export default __webpack_public_path__ + "static/media/Screenshot_2.db5f3042.webp";